import SupplierService from '@/services/SupplierService';
import TexService from '@/services/TEXService';

export default {
  async getToken (query) {
    const { claimType } = query;
    const { url } = await TexService.singleSignOn({ claimType });

    return url;
  },
  redirectUrlGenerator ({ token }) {
    return token;
  },
  getGtmEvent () {
    return {
      event: 'GAEvent',
      eventCategory: 'AccountSSOPage',
      action: 'TEX SSO',
      eventLabel: SupplierService.getSupplierId(),
    };
  },
};
